import { getData } from '@common/services/requestService';
import { createAsyncThunkWithCustomErrorHandling } from '../helpers';

export const fetchUserData = createAsyncThunkWithCustomErrorHandling('user/user', async () => {
  const data = await getData('/user', '');

  return data;
});
